import { Button, Container } from '@mui/material'
import { ButtonEx, FlexGrowCol, FlexGrowRow } from '@xylabs/sdk-react'
import { Quadkey } from '@xyo-network/sdk-xyoworld-js'
import { useContext } from 'react'
import { Helmet } from 'react-helmet'
import JsonView from 'react-json-view'
import { useParams } from 'react-router-dom'

import { AuctionProvider, GeotokenProvider, MinterAuctionContext } from '../Contexts'
import WorldBasePage from './WorldBasePage'

interface DetailsProps {
  quadkey: Quadkey
}

const Details: React.FC<DetailsProps> = (props) => {
  const { quadkey } = props
  const { auction, refresh } = useContext(MinterAuctionContext)
  const onRefreshClicked = () => {
    refresh?.()
  }
  return (
    <FlexGrowRow padding={2} busy={!auction}>
      <FlexGrowRow paper>
        <FlexGrowCol>
          <FlexGrowRow bgcolor="white" margin={2} padding={2} justifyContent="flex-start">
            <JsonView src={auction?.toJsonObject() ?? {}} />
          </FlexGrowRow>
          <FlexGrowRow display="flex" justifyContent="space-between" padding={1}>
            <ButtonEx to={`/auction/${quadkey.toBase4HashLabel()}`}>Back</ButtonEx>
            <ButtonEx to={'/auctions/js'}>All</ButtonEx>
            <Button onClick={onRefreshClicked}>Refresh</Button>
          </FlexGrowRow>
        </FlexGrowCol>
      </FlexGrowRow>
    </FlexGrowRow>
  )
}

const AuctionJsonPage: React.FC = () => {
  const { id } = useParams()
  const quadkeyRequested = (id === 'fhr' ? Quadkey.root : Quadkey.fromBase4String(id)) ?? Quadkey.root

  return (
    <WorldBasePage>
      <AuctionProvider quadkey={quadkeyRequested}>
        <GeotokenProvider quadkey={quadkeyRequested}>
          <Helmet title="Geotoken Json" />
          <Container>
            <Details quadkey={quadkeyRequested} />
          </Container>
        </GeotokenProvider>
      </AuctionProvider>
    </WorldBasePage>
  )
}

export default AuctionJsonPage
